module.exports = __webpack_public_path__ + "media/images/press_kit/test/email/main-white-08a7e3536518031b48097d2d0f0a025f.png";